/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';

/**
 * GetCmsListContent Input Action
 */
export class GetCmsListMyLibraryInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CMS_LIST_MY_LIBRARY`;
    public getCacheObjectType = () => 'CMS_LIST_MY_LIBRARY';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCmsListMyLibraryData {
    totalItem: any;
    dataLibrary: AttributeValue[];
    mess: string | null;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCmsListMyLibraryInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetCmsListMyLibraryInput, ctx: Msdyn365.IActionContext): Promise<IGetCmsListMyLibraryData | null> {
    let pageID: string | null = '';
    let searchParam: string = '';
    let userId: string | undefined = ctx.requestContext.user.customerAccountNumber;
    if (ctx && ctx.requestContext && ctx.requestContext.url) {
        if (ctx.requestContext.url.requestUrl) {
            pageID = ctx.requestContext.url.requestUrl.searchParams.get('filter');
            searchParam = ctx.requestContext.url.requestUrl.search;
        }
    }
    if (userId === undefined || userId === '') {
        userId = '1';
    }
    if (pageID !== '') {
        const frontApiEndpoint = ctx.requestContext.app.config.cmsAPIEndpoint && ctx.requestContext.app.config.cmsAPIEndpoint;
        const requestUrl = `${frontApiEndpoint}/api/list/library/tab/${userId}/en${searchParam}`;
        const result = await Msdyn365.sendRequest<IGetCmsListMyLibraryData>(requestUrl, 'get')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                ctx.trace('[GetCmsListMyLibrary] Failed to get list my libary.');
                throw error;
            });
        return result;
    }

    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCmsListMyLibraryData>>action,
    // TODO: Give your data action a unique id
    id: 'GetCmsListMyLibrary',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
